import axios from 'axios'
import qs from 'qs'

const request = axios.create({
  baseURL: window.booqableOptions.apiURL
})

request.interceptors.request.use((config) => {
  config.paramsSerializer = (params) => {
    return qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false
    })
  }

  return config
})

// Inject the store provider
request.interceptors.request.use((config) => {
  if (window.booqableOptions?.storeProvider) {
    config.headers.set('X-Booqable-Store-Provider', window.booqableOptions.storeProvider)
  }

  return config
})

export default request
